import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding: 15px 25px;
  width: 100%;
  box-sizing: border-box;
  gap: 15px;

  border-bottom: 1px solid #00000017;
`;

export const InformationContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 10px;

  flex-wrap: wrap;
  font-size: 10px;
`;

export const InformationWrapper = styled.div`
  gap: 30px;
  display: flex;
  flex-direction: row;
`;

export const HeaderSection = styled.div`
  display: flex;
  gap: 10px;

  h1 {
    font-size: 14px;
  }
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const Label = styled.div`
  font-weight: 700;
  line-height: 7px;
  letter-spacing: 0em;
`;

export const Value = styled.div`
  font-weight: 500;
  letter-spacing: 0em;
`;
